import Line from '../canvas/line'
import { IndicatorType } from '../constants/common'
import EMA from '../helpers/ema'
import { drawInVisibleArea } from '../utils/draw_in_visible_area'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class Trix extends Indicator<Attrs> {
  static type = IndicatorType.Trix
  static label = 'TRIX'

  trix: number[] = []
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary()) {
      this.trix = []
      const ema1 = new EMA(this.period)
      const ema2 = new EMA(this.period)
      const ema3 = new EMA(this.period)
      let prev = 0

      for (let i = 0; i < this.data.close.length; i++) {
        ema1.add(this.data.close[i])
        ema2.add(ema1.value)
        ema3.add(ema2.value)
        if (prev > 0) {
          this.trix[i] = (ema3.value * 100) / prev - 100
        }
        prev = ema3.value
      }
      this.lastValue = this.trix.last() ?? null
    }
    const { min, max } = this.trix.length > 0 ? this.computeVisibleMinMax(this.trix) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    new Line(
      {
        x1: -this.leftOffset,
        x2: -this.leftOffset + this.contentWidth,
        y1: Math.round(this.fy(0)),
        y2: Math.round(this.fy(0)),
        strokeStyle: '#ff8787',
        dashLength: 3,
      },
      this.model
    ).render(context)
    context.set('strokeStyle', this.getChartLayoutSettings().IndicatorSettings.general.Colors.line)
    context.translate(0.5, 0.5)
    context.beginPath()
    drawInVisibleArea(this.data.close, 0, this.fx, this.leftOffset, this.width, (i: number, x: number) => {
      if (this.trix[i]) context.lineTo(x, ~~this.fy(this.trix[i]))
    })
    context.stroke()
    context.translate(-0.5, -0.5)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 9,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `TRIX ${this.period}`
  }
}

export default Trix
